import axios from 'axios';

const apiKey = 'be5df98c14msh942da60fb765353p14b542jsn644797c8ac7b';

export const fetchNewQuote = async () => {
	const option = {
		method: 'GET',
		url: 'https://famous-quotes4.p.rapidapi.com/random',
		params: {
			category: 'all',
			count: '1',
		},
		headers: {
			'X-RapidAPI-Key': apiKey,
			'X-RapidAPI-Host': 'famous-quotes4.p.rapidapi.com',
		},
	};

	try {
		const response = await axios.request(option);
		return response.data;
	} catch (error) {
		console.error(error);
	}
};
